import { activityLabelsById, ActivityType } from '@bioliberty/core';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getFeatureFlag } from '../stores/slices/feature-flags';

export function useActivityTypeChoices() {
  const { isEnabled: isComputerVisionEnabled } = useSelector(getFeatureFlag('computerVision'));

  return useMemo(
    () =>
      Object.entries(activityLabelsById)
        .map(([value, label]) => ({ value, label }))
        .filter(
          ({ value }) => value !== ActivityType.ALL && (value !== ActivityType.CV_MODE || isComputerVisionEnabled)
        )
        .sort((a, b) => a.label.localeCompare(b.label)),
    [isComputerVisionEnabled]
  );
}
